export const colors = {
  xboxgreen: "#107c10", // green
  linkedinblue: "#0072b1",
  twitterblue: "#1DA1F2",
  slategray: "#3a3a3a",

  // textColor: "#2d2d2d",
};

export const variables = {
  mobile: 768,

  pagePadding: 16, // padding on left and right sides of page

  // bodyFont: '"Open Sans", serif',
  // headerFont: '"Days One", serif',
  // secondaryFont: '"Catamaran", sans-serif',
};
